import { Button, Paper } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../../../Components/Header/Header";
import MetaData from "../../../../Components/MetaData";
import { getCurrentUserTickets } from "../../../../Redux/Actions/Tickets";
import Loader from "../../../../Utils/Loader";
import { errorNotify, successNotify } from "../../../../Utils/toast";
import { useStyle } from "../../../HR/Pages/Attendance/attendance-styles";
import "../../../HR/Pages/LeaveManagement/LeaveManagement.css";
import TicketCreateModal from "../../../HR/Pages/Ticket/TicketCreateModal";
import { leaveStyle } from "../Leaves/leave-styles";
import AssignedTickets from "./AssignedTickets";
import MyTickets from "./MyTickets";

const Tickets = () => {
  const classes = useStyle();
  const classes2 = leaveStyle();
  const [tab, setTab] = useState(1);
  const [modalOpen, setModalOpen] = useState(false);
  const [editTicketId, setEditTicketId] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const dispatch = useDispatch();
  const {
    createTicket,
    success,
    error: createError,
  } = useSelector((state) => state.CreateTicket);
  const {
    success: updateSuccess,
    updatedTicket,
    error: updateError,
  } = useSelector((state) => state.updateTicketContent);
  const { loading, tickets, ticketsCount } = useSelector(
    (state) => state.currentUserTickets,
  );

  useEffect(() => {
    dispatch(getCurrentUserTickets(page, rowsPerPage));
  }, [page, rowsPerPage, dispatch]);

  useEffect(() => {
    if (success) {
      successNotify(createTicket.message);
      dispatch({ type: "CREATE_TICKET_RESET" });
      setModalOpen(false);
      dispatch(getCurrentUserTickets(page, rowsPerPage));
    }
    if (createError) {
      errorNotify(createError);
      dispatch({ type: "CLEAR_ERRORS" });
    }
  }, [success, createError, createTicket, dispatch, page, rowsPerPage]);

  useEffect(() => {
    if (updateSuccess) {
      successNotify(updatedTicket?.message);
      dispatch(getCurrentUserTickets(page, rowsPerPage));
      setModalOpen(false);
      setEditTicketId(null);
      dispatch({ type: "UPDATE_TICKET_CONTENT_RESET" });
    }
    if (updateError) {
      errorNotify(updateError);
      dispatch({ type: "CLEAR_ERRORS" });
    }
  }, [updateSuccess, updateError, updatedTicket, dispatch, page, rowsPerPage]);

  const handleAssignedTickets = () => {
    setTab(2);
  };

  const openCreateModal = () => {
    setEditTicketId(null);
    setModalOpen(true);
  };

  return (
    <div className="page_responsive">
      <div className="time_sheet_main">
        <MetaData title={`Tickets -- HRM`} />
        <Header title="TICKETS" />
        <Paper className={classes2.button_container}>
          <Box
            sx={{
              py: 3,
              px: 2,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Button
                variant="contained"
                className={classes2.tab_btn}
                onClick={() => setTab(1)}
              >
                My Tickets
              </Button>
              <Button
                variant="contained"
                className={classes2.tab_btn}
                onClick={handleAssignedTickets}
              >
                Assigned Tickets
              </Button>
            </Box>
            <Button
              variant="contained"
              className={classes2.add_leave_btn}
              onClick={openCreateModal}
            >
              <AiOutlinePlus style={{ marginRight: "5px" }} /> Add Ticket
            </Button>
          </Box>
        </Paper>
        <Box sx={{ px: 2 }}>
          {tab === 1 ? (
            loading ? (
              <Loader />
            ) : (
              <MyTickets
                classes={classes}
                ticketsPage={page}
                setTicketsPage={setPage}
                ticketsRows={rowsPerPage}
                setTicketsRows={setRowsPerPage}
                tickets={tickets}
                ticketsCount={ticketsCount}
                onEditTicket={(id) => {
                  setEditTicketId(id);
                  setModalOpen(true);
                }}
              />
            )
          ) : (
            <AssignedTickets />
          )}
        </Box>
      </div>
      <TicketCreateModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        editTicketId={editTicketId}
        onEditComplete={() => setEditTicketId(null)}
      />
    </div>
  );
};

export default Tickets;
